import { createTheme } from "@mui/material";

// A small letter-spacing bump, scoped to the landing page only. MUI's default
// typography variants each set their own explicit letter-spacing (so a plain
// CSS-inheritance approach from a wrapper element wouldn't reach Typography/
// Button text) — extending the app's theme here is what actually cascades to
// every variant used on this page.
export const createLandingTheme = (outerTheme) =>
  createTheme(outerTheme, {
    typography: {
      h1: { letterSpacing: "0.01em" },
      h2: { letterSpacing: "0.01em" },
      h3: { letterSpacing: "0.01em" },
      h4: { letterSpacing: "0.01em" },
      h5: { letterSpacing: "0.01em" },
      h6: { letterSpacing: "0.01em" },
      body1: { letterSpacing: "0.02em" },
      body2: { letterSpacing: "0.02em" },
      button: { letterSpacing: "0.04em" },
      caption: { letterSpacing: "0.02em" },
      overline: { letterSpacing: "0.08em" },
    },
  });
